// API configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const API_ENDPOINTS = {
  login: `/users/login`,
  register: `/auth/register`,
  provinces: `/auth/provinces`,
  roles: `/auth/roles`,
  refresh: `/users/refresh`,
  logout: `/users/logout`,
  me: `/users/me`,
  session: `/users/session`,
} as const;
